import script from "./CentralLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./CentralLoader.vue?vue&type=script&lang=ts&setup=true"

import "./CentralLoader.vue?vue&type=style&index=0&id=2b313089&lang=scss"

const __exports__ = script;

export default __exports__